module.exports = __webpack_public_path__ + "media/25.e955cf0b.ogg";